export function checkInputPage() {
    const { prop_sx_bankName, prop_sx_bankMFO, prop_sx_bankAccount, prop_sx_bankIBAN, prop_sx_bankCurrency } = this.state;
    if (!(prop_sx_bankName && prop_sx_bankMFO && prop_sx_bankAccount && prop_sx_bankIBAN && prop_sx_bankCurrency)) {
        return false;
    }
    return true;
}